import { render } from "./Download.vue?vue&type=template&id=59878fcd&scoped=true&ts=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=59878fcd&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59878fcd"]])

export default __exports__